import { z } from "zod";

const state = z.enum([
  "START",
  "NOT_RETURNED_PENALTY",
  "RETURN_PENDING",
  "COMPLETED",
]);

const caseContext = z.enum(["TERMINATION", "14CANCELLATION", "TROUBLE-TICKET"]);

export const modemReturnOrchestrator = z.object({
  type: z.literal("NJU_FTTH_MODEM_RETURN"),
  state: state.optional(),
  caseContext: caseContext.optional(),
  modemSerialNumber: z.string().optional(),
  caseTimestamp: z.string().optional(),
  contractTerminationDate: z.string().optional(),
  contractPenaltyFee: z.number().optional(),
});

export type IModemReturnOrchestrator = z.infer<typeof modemReturnOrchestrator>;
